import { createRouter, createWebHistory } from 'vue-router'
import routes from './routes'
import { setupRouterGuard } from './guard'

const router = createRouter({
  history: createWebHistory(import.meta.env.VITE_BASE_URL || '/'),
  routes,
  scrollBehavior: () => ({ left: 0, top: 0 }),
})

setupRouterGuard(router)

export default router
